(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 71862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var src_components_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71605);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


var _excluded = ["type", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var HIT_SLOP = {
  top: 12,
  bottom: 12,
  left: 0,
  right: 0
};

var Button = function Button(props) {
  var type = props.type,
      children = props.children,
      touchableOpacityProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  var disabled = Boolean(props.disabled);
  var style = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () {
    return [type !== 'link' && buttonStyles.paddedRoot, buttonStyles[type], disabled && buttonStyles.disabled, touchableOpacityProps.style, props.asCircle && buttonStyles.circular, props.style];
  }, [type, disabled, props.style]);

  var textEl = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    style: [src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.T12M */ .pn.T12M, buttonTextStyles[type], props.textStyle],
    children: children
  });

  if (props.onPress != null) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default()), _objectSpread(_objectSpread({
      disabled: disabled,
      hitSlop: HIT_SLOP
    }, touchableOpacityProps), {}, {
      style: style,
      children: [props.leftAdornment, textEl, props.rightAdornment]
    }));
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7___default()), {
      style: style,
      children: [props.leftAdornment, textEl, props.rightAdornment]
    });
  }
};

var buttonStyles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default().create({
  paddedRoot: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 2 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit,
    height: 6 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit,
    borderRadius: 3 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit
  },
  primary: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.Bolt */ .Te.Bolt
  },
  secondary: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.BackgroundGray */ .Te.BackgroundGray
  },
  danger: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.BackgroundGray */ .Te.BackgroundGray
  },
  disabled: {
    opacity: 0.5
  },
  circular: {
    paddingHorizontal: 0,
    width: 6 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit
  },
  link: {}
});
var buttonTextStyles = {
  primary: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CWhite */ .pn.CWhite,
  secondary: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CMidnight */ .pn.CMidnight,
  danger: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CAccentRed */ .pn.CAccentRed,
  link: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CPositive */ .pn.CPositive
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 63317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 4 modules
var Layout = __webpack_require__(66001);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Text/index.tsx
var Text = __webpack_require__(71605);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/Home/index.tsx














var BlogPreviewCell = function BlogPreviewCell(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: constants/* GridStyle.MB4Unit */.Hy.MB4Unit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: constants/* GridStyle.MBUnit */.Hy.MBUnit,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: constants/* GridStyle.MBUnit */.Hy.MBUnit,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          style: [constants/* TextStyle.T12M */.pn.T12M, constants/* TextStyle.CBolt */.pn.CBolt],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: props.tag.toUpperCase()
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: props.href,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: "block mt-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              style: [constants/* TextStyle.T24M */.pn.T24M, constants/* GridStyle.MBUnit */.Hy.MBUnit],
              children: props.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              style: [constants/* TextStyle.T16R */.pn.T16R, constants/* TextStyle.CDarkGray */.pn.CDarkGray],
              children: props.description
            })]
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: {
        flexDirection: 'row'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: {
          width: constants/* Grid.dp */.rj.dp(36),
          height: constants/* Grid.dp */.rj.dp(36),
          borderRadius: constants/* Grid.dp */.rj.dp(18),
          overflow: 'hidden',
          marginRight: constants/* Grid.dp */.rj.dp(12)
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: props.authorImageUrl,
          width: 128,
          height: 128,
          alt: "Photo of ".concat(props.authorName)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {
          justifyContent: 'center'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          style: [constants/* TextStyle.T12M */.pn.T12M],
          children: props.authorName
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
          style: [constants/* TextStyle.T12R */.pn.T12R, constants/* TextStyle.CDarkGray */.pn.CDarkGray],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("time", {
            dateTime: props.dateTime,
            children: props.date
          }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            "aria-hidden": "true",
            children: "\xB7"
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [props.readingDuration, " min read"]
          })]
        })]
      })]
    })]
  });
};

function Home() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: styles.contentContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* EdgeGutter */.MX, {
        style: styles.contentColumn,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: constants/* GridStyle.MB4Unit */.Hy.MB4Unit,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            style: constants/* TextStyle.T42B */.pn.T42B,
            children: "The OneShop Seller Guide"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            style: [constants/* TextStyle.T16R */.pn.T16R, constants/* TextStyle.CDarkGray */.pn.CDarkGray],
            children: "Learn how to become a top seller on marketplaces. News and tips about selling and OneShop."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/selling-on-depop",
          tag: "Depop",
          title: "Selling On Depop? 10 Effective Tips for Listing on Depop",
          description: "Selling on online marketplaces like Depop can be part-time work for some. After all, selling on the internet is proven to be convenient. But even if it is only a side hustle to you, you can always take it more seriously to increase earnings. Simply posting photos and stating what kind of item you are offering are not enough. Potential buyers tend to flock to attractive listings, especially when they have great descriptions, are written under the right category, and have effective keywords. We have listed down effective ways to describe your item's listing and be one of the top sellers on Depop.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/boost-ebay-sells-with-seo-tips",
          tag: "eBay",
          title: "Boost Your eBay Sales With These Easy SEO Tips",
          description: "With billions of transactions every day, selling on eBay has become highly competitive, and listing and putting up photos of your products is not enough. Having an effective marketing strategy is crucial, and this includes how you write product titles and descriptions and how you categorize each one.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-seller-fees",
          tag: "Mercari",
          title: "Everything You Need To Know About Mercari Seller Fees",
          description: "The Japanese e-commerce marketplace has grown since 2013, with over 19 million monthly active users. It has become a trusted app for buying and selling a wide variety of items like their competitors Poshmark and the Facebook marketplace. But like any other online shopping destination, Mercari has different fees that it charges its sellers. Here is a guide on Mercari Selling Fees and how you can get the best out of the selling platform.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-shipping",
          tag: "Grailed",
          title: "Grailed Shipping: How to Nail Shipping on Grailed",
          description: "There are a lot of pros to selling on Grailed. One of them is knowing how to navigate your way to ship your items. This article will tell you how you can nail your Grailed shipping like a pro.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/9-marketplaces-like-depop",
          tag: "Depop",
          title: "9 Marketplaces Like Depop - 2022",
          description: "Depop is the most used app for online selling. And with the whole e-commerce world keeping up with the trend, many other marketplace competitors are picking up with their popularity. Find out here what other fashion resale sites are out there where you can list your items and reach more potential buyers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/beyond-poshmark",
          tag: "Poshmark",
          title: "Beyond Poshmark - 10 Online Marketplaces For Your Pre-loved Clothes and Items",
          description: "Over the years, e-commerce witnessed incredible growth. In 2021, the e-commerce sales in the US alone reached $870 billion, which is 50.5% higher than the sales from 2019. Given public health and safety concerns, nearly 47% of adults changed their shopping behavior. Online marketplaces have been the go-to destinations for both essential needs and leisure items.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-tip-vacation",
          tag: "Mercari",
          title: "Mercari Tip: How To Turn On Vacation Mode On Your Account",
          description: "The prominence of the online marketplace has made it easier for people to earn and, at the same time, give away their pre-loved items\u2014similar to a garage sale. This is a great exchange, but on the other hand, it makes it difficult to know which platform works best for you. Thankfully, some features distinguish them from each other.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/selling-on-kidizen",
          tag: "Kidizen",
          title: "Selling on Kidizen? Use Promoted Listing To Boost Your Sales!",
          description: "With hundreds of accounts selling on Kidizen, you may find yourself competing with them\u2013trying different ways to get noticed by potential buyers and close deals with them. While there are indeed several strategies you can adopt, what you can focus on in the meantime is doing Promoted Listings.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-seller-protection",
          tag: "Poshmark",
          title: "Poshmark Seller Protection - How to Safely Sell on Poshmark",
          description: "Having a retail business in an online platform like Poshmark or other marketplaces such as Depop, Mercari, Amazon, eBay, Facebook marketplace, and the likes is truly rewarding because it lets you generate income from your closet. It is not a secret that many people nowadays, especially with the pandemic, do their shipping in the comforts of their homes; hence online sellers are earning more than ever.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-shipping",
          tag: "Depop",
          title: "Depop Shipping 2022 - The Simple Guide to Depop Shipping your Sales",
          description: "Depop is a social media platform for buying and selling second-hand items. The company offers sellers the option to choose their own shipping costs. However, this can lead to many mistakes in pricing, which will hurt your business and discourage buyers from purchasing from you. This article will break down the basics of Depop's shipping costs for sellers, shipping and packaging fees, and how to set your price right!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-negotiation",
          tag: "Poshmark",
          title: "How To Negotiate On Poshmark - The Seller's Guide to Effective Offers",
          description: "As with any business, negotiation is a key factor that makes a transaction successful. Find out how you can effectively negotiate with your potential buyers and see how it can help you increase your sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/tricks-to-selling-on-mercari",
          tag: "Mercari",
          title: "Top 9 Mercari Tips and Tricks to Boost Sales - 2022",
          description: "Once you joined the online marketplace, you discovered how fast and convenient it is to become an entrepreneur in the digital landscape. But as you have probably experienced, online selling is not simply taking photos of your pre-loved goods and posting them. Selling demands a lot of time, effort, and learning to increase your sales. You may feel frustrated when your listings get ignored, but it is natural. Fortunately, there are smart strategies to help you keep those sales coming.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-seller-protection",
          tag: "Mercari",
          title: "Protect your Mercari Business - Mercari`s Seller Protection",
          description: "Mercari is a selling platform for almost everything under the sun. It is ideal for sellers who have a myriad of different items to offer and wish to house them on one platform or those looking for another outlet to sell items under categories not hosted by other online marketplaces like Poshmark.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/tradesy-shipping-essentials",
          tag: "Tradesy",
          title: "Tradesy Shipping 101: The Essentials to Get You Started",
          description: "Sellers' shipping options, the pros and the cons, and all there is to know about sending items to buyers on Tradesy.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-listing-templates",
          tag: "Poshmark",
          title: "Poshmark Listing Templates: The Secret to Top Sales",
          description: "Listing templates are the body text in the item that is for sale. Think of it as dedicated ad space for each item you are aiming to sell. You would want your copy to be short and engaging, informative but not stiff.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "November 9th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/etsy-seller-protection",
          tag: "Etsy",
          title: "Etsy Seller Protection: What It Is and How It Works",
          description: "As an Etsy seller, you want to know that your items are protected in the event of a dispute. That\u2019s where Etsy Seller Protection comes in. Here\u2019s what it is and how it works.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 24th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-suspended-account",
          tag: "eBay",
          title: "eBay Suspended Account: Why It Happens and What To Do",
          description: "An eBay seller's nightmare is getting their account suspended or restricted. Here's how to get out of this sticky seller situation.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 21st, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/how-to-price-your-etsy-listings",
          tag: "Etsy",
          title: "How to Price your Etsy Listings: The Basics of a Profitable Reselling Business",
          description: "Barely making money? Never operate at a loss again with our primer on pricing your items right.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 21st, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/etsy-suspended-account",
          tag: "Etsy",
          title: "Etsy Account Suspended: Here's How to Avoid It",
          description: "Have you received an email from Etsy that your account has been suspended? If so, don't panic! This article will cover what happens when your Etsy account is suspended and how to get it back up.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 21st, 2022",
          dateTime: "2022-02-22",
          readingDuration: "12"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vinted-feedback",
          tag: "Vinted",
          title: "Vinted Guide: How to Handle Vinted Feedback Like a Pro",
          description: "Information provided by customers, whether good or bad, will generally affect how businesses run. Here's how you can get the most out of Vinted feedback and utilize it to your advantage!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-followers",
          tag: "Grailed",
          title: "Grailed Seller Guide: 4 Effective Ways to Actively Grow Your Followers",
          description: "Getting buyers interested in your listing starts with increasing your visibility. To do this, you need to get more users to follow you\u2013and this takes effort, but it is all worth it to gain profit.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/etsy-vacation-mode",
          tag: "Etsy",
          title: "Etsy Vacation Mode: A Guide to Making Your Etsy Shop Vacation-Ready",
          description: "Do you need a break from running your Etsy shop? Then this guide is for you. We\u2019ll go over everything you need to know about Etsy vacation mode: what it does and how to turn it on.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/seller-security-is-mercari-trustworthy",
          tag: "Mercari",
          title: "Seller Security: Is Mercari Trustworthy?",
          description: "Is Mercari legit? Can you trust Mercari? Is selling on Mercari safe and secure? Discover here what Mercari security is and how you can make yourself verified.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-posh-shows",
          tag: "Poshmark",
          title: "Poshmark Posh Shows: Your New Avenue to Showcase Your Items",
          description: "What is a Posh Show? How can you host Posh Shows? Find out how you can connect with the Poshmark community through live selling with this new feature.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-sales-report",
          tag: "Mercari",
          title: "Mercari Gross Sales Report: Your Detailed Insights on Your Transactions",
          description: "What is the Mercari Gross Sales Report? How can I access my Mercari sales report? Is my Gross Sales Report important? Discover all of these in this guide.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 13th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/what-makes-a-good-listing-title",
          tag: "-",
          title: "Create A Good Listing Title And Attract Your Audience Like A Pro",
          description: "Don't let potential customers pass by your listings again by catching their attention with the top of search engine listing titles. Here's a quick guide to help you to nail your listing titles like a pro and boost your sales.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 13th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/etsy-affiliate-program",
          tag: "Etsy",
          title: "Etsy Affiliate Program: Why resellers should consider this passive income idea",
          description: "Love hunting cool finds on Etsy? Keep it up while earning a commission on the side.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 13th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-shipping-guide",
          tag: "Mercari",
          title: "The Ultimate Guide to Mercari Shipping 2022",
          description: "There are many different shipping options for Mercari, but which one is best? This guide will break down all the alternatives and help you decide on the best shipping option for you!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 13th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-photography-tips",
          tag: "Mercari",
          title: "5 Simple Yet Effective Tips To Take Good Photos for Your Mercari Listings",
          description: "Want to catch the attention of more buyers? Take clear, good photos of your items\u2013here are the proper ways to do it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 13th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/understanding-how-facebook-marketplace-shipping-works",
          tag: "Facebook Marketplace",
          title: "Understanding How Facebook Marketplace Shipping Works",
          description: "How to ship my sold listing on Facebook Marketplace? How much does Facebook Marketplace shipping cost? Uncover all the important details in this guide.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 8th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-open-2022",
          tag: "eBay",
          title: "eBay Open 2022: Joining the Biggest Seller Event of the Year",
          description: "What is eBay Open? What can I expect with eBay Open 2022? Where is eBay Open taking place this year? Discover how you can join this eBay event in this guide.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 7th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-make-offers",
          tag: "Depop",
          title: "How to Use Depop \u2018Make Offer\u2019 Feature To Boost Your Business",
          description: "Make the most out of each and every offer on Depop and boost your sales by maximizing the features on Depop like a pro.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 7th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/how-to-make-halloween-profitable",
          tag: "-",
          title: "Spooky Season: How You Can Sell and Earn More in Halloween",
          description: "Stocking up on season-relevant items helps you attract the attention of potential buyers and close sales. Here\u2019s a guide on how to do it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 7th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-sourcing-how-to-get-inventory-to-sell",
          tag: "Depop",
          title: "Depop Sourcing: Find the Best-Selling Inventory to Sell",
          description: "It can be challenging to find inventory for your Depop store. However, there are some ways you can make this process easier and more successful. Here's how:",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 7th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-authentication-process",
          tag: "Grailed",
          title: "Grailed Authentication Process: Can Sellers Trust the Grailed Moderators?",
          description: "Know all about Grailed\u2019s end-to-end digital authentication process: What to expect, how it rolls, who are the team behind this important step, and more.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 7th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vestiaire-collective",
          tag: "Vestiaire Collective",
          title: "Vestiaire Collective: Your Avenue for Selling Luxury Items",
          description: "What is Vestiaire Collective? How can you sell on Vestiaire? How much does Vestiaire take when you sell an item? Learn how to start selling on this marketplace in this reseller's guide.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 31st, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-make-a-deal-days",
          tag: "Poshmark",
          title: "How to Make More Money With Poshmark Make a Deal Days",
          description: "Here's how you can get your name out to the community and get noticed by buyers by winning big and getting more offers out to likers on Poshmark with Make a Deal Days.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 31st, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-love-or-list-it",
          tag: "Poshmark",
          title: "Love or List Daily Challenge: Why Poshers Like You Should Join",
          description: "On top of closing sales, listing on Poshmark daily can also give you cash prizes. Learn how to join the Poshmark Love or List Daily Challenge in this guide.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 31st, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshfest-2022",
          tag: "Poshmark",
          title: "PoshFest 2022: Everything You Need to Know",
          description: "Touted as the ultimate Poshmark experience, PoshFest is happening again soon. How to join PoshFest 2022? Read up and decide if it\u2019s worth a go or not.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 31st, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/is-the-realreal-worth-it",
          tag: "The RealReal",
          title: "The RealReal Seller Guide: Is it Worth Selling Here?",
          description: "If you're looking for a second-hand luxury goods platform, The RealReal is one of the best. With their easy-to-use website and detailed seller guide, it's an easy process. Keep reading to learn more about what this platform has to offer!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 31st, 2022",
          dateTime: "2022-02-22",
          readingDuration: "12"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ultimate-guide-to-stain-removal",
          tag: "-",
          title: "The Resellers' Ultimate Guide to Stain Removal",
          description: "Got a flawed item you are reluctant to list? Here, we are listing our best stain removal tips to salvage your item and get it ready to sell.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 19th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/sourcing-secondhand-inventory-101",
          tag: "-",
          title: "How to Be a Pro At Sourcing Second Hand Inventory",
          description: "Business owners rely heavily on inventory to fulfill customer orders. After all, sourcing products a crucial business asset that allows you to stock your closet with fresh items. So when it comes to sourcing second hand inventory, here's what you should know to find the best value for your customers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 19th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/the-best-depop-bots-of-2022",
          tag: "Depop",
          title: "The Best Depop Bots of 2022: The Ultimate Guide",
          description: "Are you a Depop seller looking for an easy way to sell items? A Depop bot can help you do just that. Here\u2019s everything you need to know about Depop bots, including what they do, which one to use, and why it\u2019s worth downloading them onto your desktop.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 19th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/selling-on-multiple-marketplaces",
          tag: "-",
          title: "Selling on Multiple Marketplaces: Is It Worth It?",
          description: "Managing a reselling business on a single online platform is already a challenge. Is it worth it to do it on different marketplaces too?",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 19th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/kidizen-followers",
          tag: "Kidizen",
          title: "3 Effective Ways To Grow Your Followers On Kidizen\u2013And Why It Matters",
          description: "Growing the number of your followers is one of the crucial goals to achieve as a reseller. It gives you the much-needed exposure so you can sell your listings fast\u2013here\u2019s how to do it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 19th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-packaging-guide",
          tag: "Depop",
          title: "Stay on Top of Orders With the Depop Packaging Guide",
          description: "Keep ahead of your orders and impress your buyers by mastering the art of packaging your items like a PRO with this Depop packaging guide to find out everything you need to know and more!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 13th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-hashtags",
          tag: "Mercari",
          title: "Mercari Hashtags: The Right Way To Use Them To Reach More Customers",
          description: "Beyond attractive photos, gaining exposure to your listings involves hashtags for more users to find. Get to know why and how these can help your reselling business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 13th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-goals",
          tag: "Depop",
          title: "Become Successful on Depop: Set your goals and achieve them with these tips!",
          description: "Whether you're a casual or full-time Depop seller, having clear goals and action steps are necessary to earn consistently from your reselling business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-tax",
          tag: "Grailed",
          title: "Grailed Guide 101: Understanding Grailed Sales Tax",
          description: "Selling on Grailed also comes with tax responsibilities. Here's everything you need to know about how sales tax works and how you can qualify for tax exemptions!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-bundles",
          tag: "Mercari",
          title: "The Mercari Guide For Bundles And Why This Helps You Close Sales Faster",
          description: "Part of strategizing to keep closing sales is to create bundles\u2013you attract more buyers keen on discounts while they get to save and purchase what they want from you.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vinted-return-and-refund-policy",
          tag: "Vinted",
          title: "Seller's Guide to Vinted Return and Refund Policy",
          description: "Build your credibility as a seller by handling return and refund requests like a pro by learning the ins and outs of the policy. Never miss a beat in responding to your customers. Here's the seller's guide to tell you how to do it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/tradesy-vacation-mode",
          tag: "Tradesy",
          title: "Take a selling break in peace with Tradesy Vacation Mode",
          description: "Your listings and potential sales need not go on a break with you. Keep your items visible with this must-know Tradesy seller feature.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-suspended-account",
          tag: "Depop",
          title: "Depop Account Suspended: Everything You Should Know to Avoid This",
          description: "Maintain a good seller reputation and avoid getting your Depop account suspended. Here are some tips to keep your account safe and your listings active.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 23rd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-inventory-management",
          tag: "eBay",
          title: "How to Management Your eBay Inventory Like a Pro",
          description: "Every seller knows that to be effective in running your business, you need to have a good grasp of how to manage your inventory as efficiently as possible. This avoids incurring additional costs, acquiring surplus inventory, and more. Find out what you need to know to nail your inventory management like a pro!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 23rd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/reactivate-vinted-listings",
          tag: "Vinted",
          title: "Vinted Guide: How to Reactivate Your Vinted Listings",
          description: "To stay competitive, knowing how to reactivate your Vinted listings is essential. Learn how it works and how to utilize this feature to your advantage!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 23rd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vinted-restricted-items",
          tag: "Vinted",
          title: "Vinted Restricted Items: The prohibited products you should never list",
          description: "Prohibited items come with red flags you must be mindful of to keep your Vinted business in good standing.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 23rd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/price-mercari-listings",
          tag: "Mercari",
          title: "Selling on Mercari: Your Guide On Setting The Right Price For Your Listings",
          description: "On top of creating attractive listings, pricing your items right is crucial to gaining profit. Here's the way to do it on Mercari.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 23rd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vinted-item-authenticity",
          tag: "Vinted",
          title: "Vinted Item Authenticity Policy",
          description: "Avoid getting your listings removed and getting your Vinted account in trouble by adhering to its Item Authenticity Policy. Build your business's integrity by proving your item's authenticity with these tips.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/fb-marketplace-offers",
          tag: "Facebook Marketplace",
          title: "Supercharge your businesses with Facebook Marketplace offers",
          description: "Explore the many ways to do offers with Facebook Commerce Manager and how each one can help you bring in more sales.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/kidizen-photo-tips",
          tag: "Kidizen",
          title: "Make Your Listings Effective With These Kidizen Photo Tips",
          description: "Don't miss a beat when it comes to ensuring that your listings are as effective to catch any buyer's attention! Learn how to make them great with these Kidizen photo tips that will make your photos stand out from your competition.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/summer-products-2022",
          tag: "-",
          title: "The Best Summer Items to Sell in 2022",
          description: "Know the trending items to sell this summer 2022 and learn helpful tricks to upsell your summer item!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-algorithm",
          tag: "Mercari",
          title: "The Trick to Selling Fast on Mercari? Get On Top Of Its Algorithm",
          description: "Managing the reseller business is no easy feat, but you can always learn the ropes with an effective tip: optimizing through relisting items.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/promoting-ebay-listings",
          tag: "eBay",
          title: "Promote Your eBay Listings on Social Media",
          description: "Empower your business and drive traffic to your eBay listings using social media and increase your conversions. Learn how you can take advantage of social media and how it works.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 12th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-electronic-selling",
          tag: "Mercari",
          title: "Top listing tips and guidelines in selling Electronics on Mercari",
          description: "Seize your chance to make brisk sales with handheld devices and gadgets under this popular product category.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 12th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/kidizen-seller-guide",
          tag: "Kidizen",
          title: "Selling on Kidizen: A Beginner's Guide",
          description: "Looking for a new way to make money? Then selling on Kidizen might be the answer! Here's everything you need to learn to start selling on Kidizen.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 12th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/fb-marketplace-vacation-mode",
          tag: "Facebook Marketplace",
          title: "Facebook Marketplace: How Vacation Mode Works",
          description: "Don't lose out on your sales even on vacation. Keep your shop visible to potential buyers by using the vacation mode on the Facebook Marketplace to help balance your business and personal life like a pro seller. Step up by creating eye-catching listings that anyone can view in the marketplace as well as in Feed, search, and other places on and off Facebook.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 12th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-verified-badge",
          tag: "Depop",
          title: "Depop Badge: How To Get Verified By Becoming a Top Seller on the App",
          description: "Similar to other social media sites, getting that blue tick beside your username feels like a badge\u2013and indeed it is\u2013for sellers, celebrities, and figures on Depop. But what exactly does this mean?",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 12th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/fb-marketplace-seo",
          tag: "Facebook Marketplace",
          title: "Facebook Marketplace SEO: Simple tips to rank high in searches",
          description: "Optimize your FB Marketplace listings with keywords that work and other ideas to reach more buyers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/tradesy-relisting",
          tag: "Tradesy",
          title: "Tradesy Basics 101: Why You Should Relist on Tradesy",
          description: "Find out why sellers are re-listing their items on Tradesy and why you should try this powerful tool!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-seller-initiated-offers",
          tag: "Grailed",
          title: "How to Earn More With Grailed Seller Initiated Offers",
          description: "Learn how to maximize your earning potential and make sales by creating seller-initiated offers that work! Find out how to give your potential buyers the best deals and gain more visibility for your business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/selling-vintage-items",
          tag: "-",
          title: "Timeless Pieces: Everything To Know About Sourcing and Selling Vintage Online",
          description: "While modern items earn a lot of attention, vintage items are a hot topic in the online marketplace that can sell at higher prices than ordinary pre-loved ones.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "June 5th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-scams",
          tag: "Grailed",
          title: "Grailed Seller Guide: 5 Tips To Avoid Getting Scammed",
          description: "Scams are common in online marketplaces\u2013even sellers can become victims. From taking quality photos to being transparent with your buyers, here are ways you can steer clear of scammers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-return-policy",
          tag: "Mercari",
          title: "The Seller's Guide to the Mercari Return Policy",
          description: "All sellers would prefer to have a low return rate. However, processing returns are unavoidable, and for Mercari sellers, this is a simple enough process to handle. Here's a guide to understanding the Mercari return policy like a pro.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-bulk-listing",
          tag: "eBay",
          title: "eBay Bulk Listing Tool: The Quickest Way to List All Your Items",
          description: "Save time and achieve your sales goals quickly by listing hundreds of products all at once using the eBay bulk listing tool!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-prohibited-items",
          tag: "Depop",
          title: "Depop Prohibited Items: What not to sell to avoid getting into trouble",
          description: "Sell safely within Depop's allowed categories to guarantee coverage under seller protection.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/tradesy-restricted-items",
          tag: "Tradesy",
          title: "Tradesy Restricted Items: Keep These Off Your List",
          description: "Learn restricted items on Tradesy, including what not to sell, how to ensure authenticity, and tools to use to win more customers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-seo",
          tag: "Mercari",
          title: "How to attract customers using Mercari SEO",
          description: "The way to earn more with your online business is by learning how to attract more customers by utilizing every seller's secret weapon: Search Engine Optimization. Do more by doing less! Here's what you need to know to gain a competitive advantage with Mercari SEO.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-how-to-price-items",
          tag: "Depop",
          title: "Pricing Items on Depop: What You Need To Know To List Items The Right Way",
          description: "Setting the price for your items can be confusing. Here's how you should do it to attract customers and gain enough profit.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-in-season-listings",
          tag: "Depop",
          title: "Make steady year-round sales with Depop in-season listings",
          description: "With sufficient planning, mindful curation, and other simple strategies, every season can be profitable for your Depop reselling business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-feedback",
          tag: "Depop",
          title: "How Depop Feedbacks Can Boost Sales and Leverage Credibility",
          description: "The way to get potential buyers to make a purchase decision is to show them how reliable you are. And with this, it is critical to ensure that the process of leaving and deleting feedback on Depop is as convenient as can be. Learn how it works and get tips to help you gain 5-star ratings.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 15th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-seller-verification",
          tag: "Grailed",
          title: "Grailed Seller's Profile Verification: Why It Matters and How To Do It",
          description: "Part of selling on marketplaces is gaining the trust of potential buyers\u2013and doing this entails building up a great profile and relationship with customers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 15th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-authentication",
          tag: "Grailed",
          title: "Grailed Authentication 101: How it Works and Why Does it Matter",
          description: "Learn how Grailed authentication works, why having your items digitally authenticated matters, and how to get more money by selling your authentic items on Grailed.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 15th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-seller-protection",
          tag: "Grailed",
          title: "Selling with confidence with Grailed Seller Protection",
          description: "Grailed assures sellers of protected sales for transactions that fully meet their criteria with its Money-Back Guarantee. Find out how to ensure your sales are covered every time.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "May 15th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-freight-spring-2022",
          tag: "eBay",
          title: "Guide to eBay Freight Shipping 2022",
          description: "Learn how eBay freight shipping works and see what type of shipping will work best for you",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-photo-tips",
          tag: "Grailed",
          title: "Grailed photo tips: Guidelines and checklist to follow for successful listings",
          description: "On Grailed, having irresistible goods to sell is not enough. Your photos must be complete and of high quality to meet the moderators' standards. Here's how to get it right every time you list.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-gadget-listing",
          tag: "eBay",
          title: "Selling Gadgets on eBay? Here Are The Simple Yet Best Ways To Do It",
          description: "Listing in-demand items like electronics on marketplaces go beyond posting photos. From creating titles and structured descriptions to setting up price points, here is the effective approach to do it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/paypal-seller-protection",
          tag: "PayPal",
          title: "Seller Guide to Securing Your Business With PayPal Seller Protection",
          description: "Here's everything you need to know as an online reseller on how you can secure your transactions with your buyers' payments with PayPal's Seller Protection.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/fb-marketplace-tax",
          tag: "Facebook Marketplace",
          title: "Sellers Guide 101:Facebook Marketplace Tax Identification",
          description: "Stay tax-compliant and get yourself familiarized with your tax responsibilities as a Facebook Marketplace seller.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-vacation-mode",
          tag: "Grailed",
          title: "Grailed Vacation Mode: Put your shipping activities on hold while continuously making sales",
          description: "Whether you\u2019re taking a real vacation or simply need to focus on other things, this Grailed seller feature allows you to take a break from shipping duties without losing sales.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-gadgets-listing",
          tag: "eBay",
          title: "Selling Gadgets on eBay? Here Are The Simple Yet Best Ways To Do It",
          description: "Listing in-demand items like electronics on marketplaces go beyond posting photos. From creating titles and structured descriptions to setting up price points, here is the effective approach to do it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/paypal-seller-protection",
          tag: "PayPal",
          title: "Seller Guide to Securing Your Business With PayPal Seller Protection",
          description: "Here's everything you need to know as an online reseller on how you can secure your transactions with your buyers' payments with PayPal's Seller Protection.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-spring-items",
          tag: "Mercari",
          title: "Declutter and Boost Your Sales with Mercari Spring Items",
          description: "Make your spring cleaning profitable by setting aside in-season items to sell on Mercari. Here are some tips and tricks.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/facebook-commerce-manager",
          tag: "Facebook",
          title: "Facebook Commerce Manager: How It Works and What You Can Do With It",
          description: "Learn how the Facebook Commerce Manager works, utilize its features, and win more customers!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-wholesale-inventory",
          tag: "eBay",
          title: "The eBay Seller Guide To Sourcing Wholesale Inventory For Your Business",
          description: "eBay has an ingenious solution to the challenging task of sourcing inventory. Find out how eBay can connect you to a trusted supplier and save you time as you focus on growing your business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/tradesy-photo-tips",
          tag: "Tradesy",
          title: "Tradesy Photo Tips: How to Take Photos That Sell on Tradesy",
          description: "Learn how to take photos that attract buyers and sell your listings on Tradesy with these easy-to-follow tips and tricks.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 20th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-buyer-groups",
          tag: "eBay",
          title: "eBay Buyer Groups: Promote your coded coupons in bulk!",
          description: "Take advantage of the eBay Buyer Groups where you can control your target audience that receives your coded coupons. Learn all about this feature and how you can use it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-taxes",
          tag: "eBay",
          title: "Navigating eBay taxes: The basics to get you started",
          description: "Should I charge sales tax on eBay? How much does a buyer pay for eBay tax? This primer helps you understand the applicable tax laws and your responsibilities as a seller in complying with them.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-local",
          tag: "Mercari",
          title: "What You Need To Know To Sell and Earn More With Mercari Local",
          description: "Learn how to boost your sales locally and earn faster by using Mercari Local to get your items delivered on the same day and get people to notice your business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-limited-or-closed-account",
          tag: "Mercari",
          title: "Mercari Limited or Closed Your Account? Get To Know The Reasons Why and How You Can Get It Back",
          description: "Familiarize yourself with how you can avoid your Mercari account from getting limited or closed. Learn the factors that cause this and how you can retrieve your account if it happens.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-pricing",
          tag: "eBay",
          title: "A Guide to Effective eBay Pricing in 2022",
          description: "Learn how to attract more potential customers with effective eBay pricing!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 14th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-listing-w-structured-data",
          tag: "eBay",
          title: "eBay Listing with Structured Data: Your Ultimate Guide to Higher Listing Visibility",
          description: "List your items strategically to help your buyers find them easily. Follow these tips on how you can list on eBay using structured data.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 8th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-multiuser-account-access",
          tag: "eBay",
          title: "eBay Multi-User Account Access: What is it, and why is it essential in growing your business?",
          description: "Having extra hands in running your eBay store is great, but making use of a feature that provides you with flexibility in delegating tasks is even better. Know all about this feature in this article.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 8th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/fb-marketplace-ads",
          tag: "Facebook Marketplace",
          title: "The Seller Guide to Using Facebook Marketplace Ads",
          description: "Learn everything you need to know about Facebook marketplace ads and how they can benefit you in turning leads into sales for your business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 8th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-scams",
          tag: "Depop",
          title: "Sellers Beware: Depop Scams You Should Watch Out For",
          description: "Discover common scams encountered by Depop Sellers and how to avoid them!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 8th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-ship-cover-insurance",
          tag: "eBay",
          title: "eBay ShipCover Insurance: Coverages and How To File Claims",
          description: "As much as sellers want to avoid parcel loss or damages, accidents happen. Thankfully, eBay has insurance that can protect you\u2013here's how.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "April 8th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-great-price-badge",
          tag: "eBay",
          title: "eBay Great Price Badge: Your eBay secret to getting your buyers' attention.",
          description: "Catch your potential buyer's attention with the eBay Great Price badge and get more conversions. Learn here how it works and how you can take advantage of this feature.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-international-trading-policy",
          tag: "eBay",
          title: "Selling Internationally on eBay? Here\u2019s What You Need To Know",
          description: "Gaining extensive exposure through international sales can help boost your earnings, but these are policies you must watch out for before closing any transactions.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-offer-to-buyers",
          tag: "eBay",
          title: "Selling on eBay? Here Are Effective Tips On Making Offers To Buyers",
          description: "Start closing sales fast and getting the best deal out of your listings through offers to buyers\u2013and here are the easy, convenient ways you can do it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-photo-tips",
          tag: "eBay",
          title: "eBay Seller Photography Guide To Get Your Listings Noticed",
          description: "Learn how to make your photos pop and get potential buyers to take notice of your listings at first glance. Level up your photography game with these practical and useful seller photo tips.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-prohibited-items",
          tag: "eBay",
          title: "Everything You Should Know About Prohibited Items On eBay",
          description: "Avoid making the mistake of listing prohibited and restricted items on eBay to keep your account out of trouble. Learn here everything you need to know about eBay's prohibited item policies.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-promotions-manager",
          tag: "eBay",
          title: "The eBay Promotions Manager: Your Guide to Selling Online",
          description: "Learn how to maximize the benefits of eBay Promotions Manager and succeed in setting up your eBay campaigns.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "12"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-refurbished-program",
          tag: "eBay",
          title: "How the eBay Refurbished Program Works for Sellers",
          description: "Discover how the eBay Refurbished Program works for sellers and its benefits that may help you become a power seller!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-scams",
          tag: "eBay",
          title: "Your Guide to eBay Scams and How to Avoid Them",
          description: "Learn how to spot the red flags of eBay scams and what you can do to avoid being a victim. Here's how to scam-proof your shop and learn what you can do when you fall victim to an eBay scam.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-seller-levels-and-performance-standards",
          tag: "eBay",
          title: "eBay Guide 101: Seller Levels and Performance Standards",
          description: "This blog will cover the basics of eBay's seller levels and the minimum performance standards, and what benefits come with being a top-rated seller.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-time-away-feature",
          tag: "eBay",
          title: "eBay Time Away Feature: Set Up Your Shop on Vacation",
          description: "Running an eBay shop can be a lot of work. When you want to take a break, how do you handle it? Time Away Feature allows you to set up your shop on vacation and will keep things running smoothly for your customers while you're away.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-unpaid-items",
          tag: "eBay",
          title: "eBay Unpaid Items: Here\u2019s how to handle them like a pro!",
          description: "A listing isn\u2019t completely sold until it\u2019s paid for. Here\u2019s what to do to make sure you\u2019re not on the losing end of a canceled transaction.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/facebook-cancellations-and-refunds",
          tag: "Facebook Marketplace",
          title: "A Seller's Guide to Dealing with Facebook Marketplace Cancellations and Refunds Safely",
          description: "Aside from managing refunds, there's more at stake for sellers when orders get canceled on FB Marketplace. Fortunately, there are ways to handle these situations well with minimized risks. Read our tips and tricks below.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/facebook-marketplace-badges",
          tag: "Facebook Marketplace",
          title: "Seller Goals: Here Are The 4 Facebook Marketplace Badges You Should Aim To Have",
          description: "As a seller, your transaction history can make or break your image and performance in the marketplace. So, your goal is to have a great commerce profile, and here's how badges can help you achieve that.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/facebook-marketplace-boosted-listing",
          tag: "Facebook Marketplace",
          title: "Facebook Marketplace Boosted Listing: How does it work \u2013 and should you give it a try?",
          description: "Boosting a listing on FB Marketplace helps you reach your target audience using customizable parameters and insights to guide your sales strategy. Let us walk you through setting it up and how you can monitor your performance.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/facebook-marketplace-prohibited-items",
          tag: "Facebook Marketplace",
          title: "Items You Can't Sell on Facebook Marketplace",
          description: "This article will discuss restricted goods and services on Facebook Marketplace and how to appeal if they mistakenly removed your item.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/facebook-marketplace-purchase-protection",
          tag: "Facebook Marketplace",
          title: "What every seller should know about Facebook Marketplace Purchase Protection",
          description: "From what qualifies for a protected purchase to how a seller can appeal a claim, we navigated the Facebook selling platform for intel to help you manage claims well.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/facebook-marketplace-scams",
          tag: "Facebook Marketplace",
          title: "Facebook Marketplace Scams: A Seller's Guide to Scam-free transactions.",
          description: "Protect yourself and your business from scammers. Learn the different kinds of scams on Facebook Marketplace and some tips on how you can avoid them.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/facebook-marketplace-shipping",
          tag: "Facebook Marketplace",
          title: "Understand How Facebook Marketplace Shipping Works",
          description: "Familiarize yourself with the ins and out of shipping on the Facebook marketplace and learn some best-kept tips to guide you along the way.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-offers",
          tag: "Grailed",
          title: "Everything You Need To Know About Grailed Offers",
          description: "Do away with the long-form guides, and let's get to the important things that you need to know on how to master your offers on Grailed and boost your sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-ebay-import-tool",
          tag: "Mercari",
          title: "Mercari eBay Import Tool: Your quick access from eBay to Mercari.",
          description: "Save more time and effort with Mercari\u2019s helpful tool that lets you save time crossposting your eBay listings to Mercari.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-items-for-spring-2022",
          tag: "Poshmark",
          title: "Spring is Finally Here: What You Should Sell This Season On Poshmark",
          description: "As a new season rolls around, here are the trends and tips you should adopt to refresh your inventory and attract new customers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/removed-ebay-listings",
          tag: "eBay",
          title: "Removed Listings on eBay: Why It Happens and How to Avoid It",
          description: "Listing on eBay is fun and profitable, but sometimes, listings on this platform get removed. Find out here the reasons behind the removal and learn some tips on how you can avoid it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vinted-discounts",
          tag: "Vinted",
          title: "Vinted Discounts: Boost your sales with this helpful Vinted features!",
          description: "No need to wonder how to make your buyers hit the 'Buy' button in no time! Here's what you need to know about the discounts you can offer to your Vinted buyers!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-sales-tax",
          tag: "Depop",
          title: "Sales Tax on Depop: What It Is About And How You Can Still Earn More Given the Deductions",
          description: "As a Depop seller, you need to consider fees that affect your business income. State sales tax is among them, but you don't need to worry about it\u2013here's why.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-authenticity-guarantee",
          tag: "eBay",
          title: "Sell with confidence with eBay Authenticity Guarantee \u2013 and keep those fraud claims at bay!",
          description: "How does eBay guarantee the authenticity of premium items? With this free authentication program, you can validate your goods as the real deal if you sell sneakers, handbags, wallets, and trading cards.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "March 29th, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-followers",
          tag: "Depop",
          title: "How to Increase Your Depop Followers Like a Pro",
          description: "Whether you\u2019re a new or a pro seller, these tips and tricks will still significantly contribute to the growth of your Depop follower count",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-returns",
          tag: "Depop",
          title: "Dealing with Depop Returns and Refunds",
          description: "Learn how to deal with customers' return requests on Depop and how you can process a refund for them.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-algorithm",
          tag: "eBay",
          title: "How to Rank Your Listings on eBay's Best Match",
          description: "Use eBay's ranking system to your advantage to be seen by more customers and increase your sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-auctions",
          tag: "eBay",
          title: "eBay Auction or Buy It Now: Which One Works Best?",
          description: "Learn of each the benefits and disadvantages, and how to get the maximum potential for what you are selling",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-refund-returns",
          tag: "eBay",
          title: "eBay Returns and Refunds Management: Mastering the Basics",
          description: "Know your seller rights and responsibilities with this guide to stay profitable with refunds and returns!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-seller-protection",
          tag: "eBay",
          title: "The Basics of eBay Seller Protection",
          description: "Learn how eBay seller protection works, what constitutes abusive buyers, and the requirements for a seller to qualify for protection.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-shipping-guide",
          tag: "eBay",
          title: "eBay Shipping Guide for Sellers",
          description: "Avoid making shipping mistakes at eBay and know the best shipping practices to minimize returns!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-store-subscription",
          tag: "eBay",
          title: "Why You Need An eBay Store Subscription",
          description: "Learn the basics of the different types of stores, fees, and benefits that comes with being an eBay seller.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/ebay-updated-fees",
          tag: "eBay",
          title: "eBay's 2022 Seller Price Increases and Fees",
          description: "From Final Value Fees, Standard Selling, Monthly Subscription to other important calculation methods, here is what you should expect starting March 1, 2022.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/grailed-seller-guide",
          tag: "Grailed",
          title: "Grailed Seller Guide: Everything You Need to Know",
          description: "Read on the must-knows for those looking to sell on Grailed. ",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/increase-depop-sales",
          tag: "Depop",
          title: "How to Boost your 2022 Sales on Depop",
          description: "From getting listings right maximizing shipping fees to cross-posting or promoting your items, here is a guide on becoming among the top Depop sellers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/increase-vinted-sales",
          tag: "Vinted",
          title: "The Best Ways to Boost Your Vinted Sales",
          description: "Great strategies lead to increase in sales. Learn here how you can boost your sales on Vinted!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/kidizen-bundles",
          tag: "Kidizen",
          title: "How to Make Multiple Sales, Faster, with Kidizen Bundles",
          description: "Zoom in on how bundling works on Kidizen and the seller strategies that help convert offers into actual sales.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/kidizen-promote-listing",
          tag: "Kidizen",
          title: "Selling on Kidizen? Use Promoted Listing To Boost Your Sales!",
          description: "Promoting your listings in Kidizen helps boost your visibility, but at a cost. Find out if it is worth it for your Kidizen business",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/kidizen-seller-protection-return-policy",
          tag: "Kidizen",
          title: "The Lowdown on Kidizen Seller Protection and Return Policy",
          description: "Protect your business in cases of returns on Kidizen and learn about how Kidizen protects their sellers like you",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/kidizen-sharing-bumping",
          tag: "Kidizen",
          title: "Kidizen Sharing (Bumping) Items to Boost Your Sales",
          description: "Finding ways to boost your sales on Kidizen? Get Bumping to boost your listings and ultimately increase your sales",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/kidizen-shipping",
          tag: "Kidizen",
          title: "Selling On Kidizen? Here's a Refresher for How Their Shipping Works",
          description: "Learn the basic logistics of selling on Kidizen, a popular resale site for kids clothings as a seller, from shipping labels and shipping time in Kidizen",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-w9",
          tag: "Mercari",
          title: "Mercari W-9 Requirements for 2022",
          description: "Starting January 1, 2022, Mercari will require sellers with $600 or more gross sales to submit a W-9. The Internal Revenue Services (IRS) and state tax agencies use the W-9 for income reporting purposes.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-ambassador-2",
          tag: "Poshmark",
          title: "Level up with the new Poshmark Ambassador II",
          description: "Aiming to achieve the latest level of Poshmark seller with Poshmark's Ambassador 2 status? Learn the requirements and how to fast-track your way to Poshmark Ambassador 2!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/resale-luxury-items",
          tag: "Crosslisting",
          title: "4 Best Sites to Resell Luxury Items",
          description: "Offload your luxury pieces with these top 4 resale marketplaces, and learn about the authentication processes, audiences, and fees for each!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/tradesey-seller-guide",
          tag: "Tradesy",
          title: "Resale on Tradesy - The Tradesy Seller Guide 2022",
          description: "Start this new year right with nailing the basics of Tradesy selling to boost your sales and attract customers this 2022",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vinted-wallet",
          tag: "Vinted",
          title: "Top Things to Know about Vinted Wallet",
          description: "Learn how you can use your Vinted Wallet as a seller, why your balance is pending, and what to do when a payout fails.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vinted-shipping",
          tag: "Vinted",
          title: "The Ultimate Vinted Shipping Guide",
          description: "The seller's cheat sheet on how to ship on Vinted. From who pays for shipping to the shipping options available to sellers and everything there is to know about successfully sending out purchased items to buyers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "February 22nd, 2022",
          dateTime: "2022-02-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/bulk-offer-poshmark",
          tag: "Poshmark",
          title: "Bulk Offer to Likers on Poshmark",
          description: "Forget about spending so much time sending Offer to Likers manually and skip the laborious and time-consuming task with Poshmark\u2019s Bulk Listing actions.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-bundles",
          tag: "Depop",
          title: "Depop Bundles: Multiple sales for you, lower shipping for buyers",
          description: "Here's how to sell bundles on Depop and make it work for you and your shop.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-discounts",
          tag: "Depop",
          title: "Boost Your Sales by Offering Depop Discounts",
          description: "Take advantage of the best Depop features to save the most money and time.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-photo-tips",
          tag: "Depop",
          title: "Depop Photo Tips to Create a Great Listing",
          description: "When you're listing on Depop, your photos are the first thing potential buyers will see. The better the picture quality, the more likely to increase sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-seller-protection",
          tag: "Depop",
          title: "Depop Seller Protection",
          description: "Sell on Depop with confidence with its Seller Protection. Learn here how it works and how you are protected!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-shop-share",
          tag: "Depop",
          title: "Depop Shop Share: Depop Promotion using Social Media",
          description: "Boost your sales with these Depop promotion tips and tricks to reach your audience. Learn here how you can use social media in promoting your Depop listings.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Depop-style-tags",
          tag: "Depop",
          title: "Making Depop Style Tags Work for You",
          description: "Use Depop's style tags to increase your Depop visbility!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Facebook-marketplace-guide-for-sellers",
          tag: "Facebook Marketplace",
          title: "The Comprehensive Guide to Selling on Facebook Marketplace",
          description: "Understand the ins and outs of selling on Facebook Marketplace, including some tips and tricks to help you have a winning business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "14"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/get-more-followers-poshmark",
          tag: "Poshmark",
          title: "How To Get More Followers on Poshmark",
          description: "Get social and grow your online business. Learn here how you can get more Poshmark followers!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/How-to-make-an-offer-on-mercari",
          tag: "Mercari",
          title: "How to Make an Offer on Mercari",
          description: "Level up your game selling on Mercari. Learn here how you can make an offer and negotiate with your potential buyers!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/How-to-organize-Poshmark-closet",
          tag: "Poshmark",
          title: "How to Organize your Poshmark Closet",
          description: "Find out how to boost your Poshmark sales by organizing your listings to attract more customers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/How-to-price-items-Poshmark",
          tag: "Poshmark",
          title: "Poshmark Selling Tips: How to Price Your Items Right",
          description: "Determine how to price your item right on Poshmark while still making a good deal for your buyers!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/How-to-provide-excellent-customer-experience-on-Mercari",
          tag: "Poshmark",
          title: "How to Provide Excellent Customer Experience on Mercari",
          description: "Earn repeat customers by providing excellent customer service to your buyers for a great selling track record!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Increasing-Visibility-on-Poshmark",
          tag: "Poshmark",
          title: "Increasing Visibility on Poshmark",
          description: "Learn how you can make more conversions on your online selling business by increasing your closet and listing's visibility on Poshmark.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Listing-on-eBay",
          tag: "eBay",
          title: "The eBay Seller Guide: Listing 101",
          description: "Learn what every seller should know about listing on eBay and the fees involved!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Mercari-Fees",
          tag: "Mercari",
          title: "Everything You Need To Know About Mercari's Seller Fees",
          description: "Like any other online shopping destination, Mercari has fees that it charges its sellers. Find out what these fees are and how you can still get the best out of Mercari",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Mercari-Goals",
          tag: "Mercari",
          title: "Achieve your Mercari Selling Goals",
          description: "Set your goal on Mercari, learn how to track them, and read about different ways to achieve your goals for Mercari Sellers",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Mercari-Promote",
          tag: "Mercari",
          title: "The Beginner's Guide to Mercari Promote",
          description: "Break down what Mercari Promote is, how does it work, and tips and tricks to sell your items faster!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Mercari-Relist",
          tag: "Mercari",
          title: "Mercari Seller Secret: Relist your old Listings!",
          description: "Learn here all you need to know about relisting to boost an unsold item's appeal and salability on the platform.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Mercari-Sellers-Guide-Top-3",
          tag: "Mercari",
          title: "Mercari Seller's Guide: The 3 Fastest Selling Categories",
          description: "Be on the lookout of these items while out sourcing for faster sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Mercari-Selling-Tips",
          tag: "Mercari",
          title: "Top Tips for Mercari Sellers",
          description: "Utilize these tips to boost your sales on a growing marketplace!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Mercari-authenticate",
          tag: "Mercari",
          title: "Mercari Authenticate",
          description: "Learn what you are buying and protect yourself from selling counterfeits!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Mercari-for-Beginners-2022",
          tag: "Mercari",
          title: "Mercari for Beginners: The Ultimate Guide 2022",
          description: "Get to know the basics for selling on Mercari! Learn the fundamentals of what Mercari is and how to get started.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Photo-editing-apps-Poshmark",
          tag: "Poshmark",
          title: "The 8 Best Photo Editing Apps for Poshmark",
          description: "Poshmark limits the number of photos per listings, so catch the attention to grow your Poshmark sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Posh-Stories",
          tag: "Poshmark",
          title: "Posh Stories and Sales",
          description: "Some sellers may think this is additional work, but delving into this new feature has many more advantages than you think.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-posh-n-sip",
          tag: "Poshmark",
          title: "Posh N' Sip: A Party for Poshmark Sellers",
          description: "Learn about opportunities to get together with other sellers and enjoy the company of others in the same reseller mindset!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Ban",
          tag: "Poshmark",
          title: "Poshmark Ban: Keep Your Account Safe and Not Get Banned",
          description: "Selling on Poshmark is fun until you put your account at risk of getting banned. Learn here how you can keep your Posh account away from getting banned permanently.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Bots-vs-Virtual-Assistants",
          tag: "Poshmark",
          title: "Poshmark Bots vs. Virtual Assistants: Which is Worth Your Money?",
          description: "The online fashion marketplace Poshmark has provided an avenue for buyers and sellers to connect, and it has a variety of tools that make the process easier. One such tool is the ability to set up a bot or virtual assistant (VA) to manage your closet on your behalf.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Closet-Insights",
          tag: "Poshmark",
          title: "Everything You Need to Know About Poshmrk's Closet Insights",
          description: "Poshmark allows you to manage your closet from anywhere you have an internet connection. In this blog, we have listed some simple tips for you to get the most out of Poshmark.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Closet-Organization",
          tag: "Poshmark",
          title: "A Guide to Organizing Your Poshmark Closet",
          description: "A closet is a place where we can all be organized and tidy. But for us who sells on Poshmark, going through our storage and sorting all clothing into the piles can be a bit overwhelming.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Community-Shares",
          tag: "Poshmark",
          title: "Easy Poshmark Strategy: What You Need To Know About Sharing",
          description: "In the Poshmark community, it matters to build your network among buyers and even fellow sellers matters. As a social e-commerce platform, they are all about creating high visibility. Whether you are selling or buying, it helps all kinds of users to achieve their goals. These take in the form of Posh parties, connecting with hosts, and even with a Poshmark ambassador.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Community",
          tag: "Poshmark",
          title: "Poshmark Community: How To Join And Why It Matters",
          description: "Beyond selling your pre-loved items, being on Poshmark dispenses several other advantages. Your initial goal may be about making a profit, but registering an account already integrates you to the buyer and seller community, also known as Poshers. With a vibrant community of over 80 million people across the US, Canada, Australia, and India, everyone is welcome to join the social marketplace.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Copy-Feature",
          tag: "Poshmark",
          title: "Poshmark Copy Feature",
          description: "Save time in creating a new listing from your existing Poshmark listings and boost your sales. Learn here how to you can utilize the Poshmark Copy feature!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Designer",
          tag: "Poshmark",
          title: "Poshmark Tip: Where To Source and How To Sell Designers",
          description: "When you visit online marketplaces, you will notice one type of item that sells well: designers. No matter the category, branded products almost always draw the attention of shoppers. Potential buyers purchase the name of the item, along with the company\u2019s values, characteristics, and the quality they integrate into their products.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-for-beginners",
          tag: "Poshmark",
          title: "Poshmark For Beginners",
          description: "Starting your Poshmark closet? Here is our beginner's guide with the essential details that you have to learn to be successful in online selling!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "14"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Guidelines-2022",
          tag: "Poshmark",
          title: "Poshmark Guide 2022: Welcome the new year with more sales!",
          description: "New year, new start! Here is your Poshmark guide 2022 to make your Poshmark venture successful.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "12"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Hashtags",
          tag: "Poshmark",
          title: "Poshmark Hashtags: The hacks to make your closet discoverable and attract new buyers.",
          description: "Level up your social media game with the best hashtags \u2013 plus how and when to use them \u2013 to help you grow your Poshmark business.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Holiday-Trend",
          tag: "Poshmark",
          title: "Best Poshmark Holiday Items",
          description: "Holiday trends can get pricey. But to still get in on the action, you're going to need some quick-selling items. We've uncovered the best Poshmark items you can buy now to get on the holiday trend train in this time of year.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Host-Picks",
          tag: "Poshmark",
          title: "Poshmark Host Picks: Strategies to Stand Out and Get Chosen",
          description: "Getting your listings featured as Host Picks attracts more potential buyers and boosts your closet\u2019s visibility. Take advantage of this free exposure with our easy tips.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Inventory-Management",
          tag: "Poshmark",
          title: "Poshmark Inventory Management",
          description: "Scale up your reselling business with winning strategies for organizing and keeping track of your inventory.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Keywords",
          tag: "Poshmark",
          title: "Poshmark Keywords",
          description: "There are many things that you can do to boost your sales. To do that, you will have to make your Poshmark listings visible to potential buyers. Learn here the importance of keywords and how it can help your listings appear more on search results.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-My-Inventory-Report",
          tag: "Poshmark",
          title: "Poshmark My Inventory Report 101 ",
          description: "Poshmark Inventory is a useful tool for Poshmark sellers. The report provides insights into the products performing well, items with high engagement, and more. It's easy to use and gives you everything you need to make smart decisions about your Poshmark business. ",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-My-Shoppers",
          tag: "Poshmark",
          title: "Poshmark My Shoppers: The New Tool Every Seller Should Benefit From",
          description: "Learn all about this new data-driven feature that leverages likes, bundles, and comments to get you closer to securing sales.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Offers",
          tag: "Poshmark",
          title: "Poshmark Offers",
          description: "Get your Poshmark sales going using Poshmark Offers. Learn here all that you need to maximize the potential of this powerful Posh feature!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Packaging-Ideas",
          tag: "Poshmark",
          title: "Poshmark Packaging Ideas ",
          description: "Poshmark is a clothing and accessory trading site that lets you buy and sell clothes, shoes, handbags, and other accessories. One of the main things to remember when packing sold items on Poshmark is to package them safely so they will not be damaged while in transit. ",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Reposh",
          tag: "Poshmark",
          title: "How-To Guide in Poshmark Reselling",
          description: "Poshmark is a mobile app that allows users to buy and sell items online. In this post, we provide a how-to guide for the most common features of the app. We also offer step-by-step instructions on how to use the app for sellers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Return-Policy",
          tag: "Poshmark",
          title: "Poshmark\u2019s Easy-to-Use Return Policy",
          description: "When you receive an item you don't want, you can return it for an exchange, refund, or store credit with Poshmark\u2019s easy-to-use return policy.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Share-Groups",
          tag: "Poshmark",
          title: "Sharing is Caring: What to Know About Poshmark Share Groups",
          description: "Poshmark Share Groups allow Poshers to share an item from their closet that someone else might want to purchase. These groups are based on specific interests or style preferences, so they're easy for shoppers to find what they're looking for.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-titles",
          tag: "Poshmark",
          title: "A Crash Course on Crafting Captivating Poshmark Titles",
          description: "In this article, we'll show you the anatomy of a great listing title, plus more tips to help you create winning titles every time.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-tools",
          tag: "Poshmark",
          title: "5 Poshmark Tools You Need - Rocket your Poshmark Sales",
          description: "If you're looking to boost your Poshmark sales, these five tools are an awesome place to start. We'll show you how the tools can boost your sales and help you maximize your profits.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-trading",
          tag: "Poshmark",
          title: "Guide for Your First Trade in Poshmark",
          description: "Trading on Poshmark has gotten really popular over the years. And whether you agree or not with trading on Poshmark it can be helpful to know how to do it in the event that you need to put it into good use. In this blog, we\u2019ll discuss what you need to know about doing your first trade on Poshmark and how to mitigate the risks associated with it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Wholesale",
          tag: "Poshmark",
          title: "Poshmark Wholesale: Is It Worth It?",
          description: "This blog will cover everything you need to know about being a Poshmark wholesale vendor, what Poshmark wholesale means, and why you should want to be one.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Promoting-poshmark-holiday-sales",
          tag: "Poshmark",
          title: "The Holiday Rush: 5 Best Tips To Sell Well On Poshmark",
          description: "From doing an inventory of what you prefer to keep to listing the apparel, accessories, and other items you want to sell, here are a few Poshmark tips to prepare you for the holiday sale on the social e-commerce app.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Secrets-to-Selling-on-Poshmark",
          tag: "Poshmark",
          title: "Secrets to Selling on Poshmark",
          description: "Here are some tips and tricks to help you succeed on this reselling platform. ",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Selling-On-Vinted",
          tag: "Poshmark",
          title: "Selling on Vinted: All It Takes To Get You Started",
          description: "Vinted is an international online marketplace where you can sell secondhand items without fees. Even better is that the buyer pays for shipping, so all you have to take care of is marketing, selling, and packaging your items.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Selling-on-Poshmark-Vs-Mercari",
          tag: "Poshmark",
          title: "Selling on Poshmark vs. Mercari ",
          description: "Do you want to learn where you can get good earnings by selling online? Find out here what selling on Poshmark and Mercari is like.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Tradesy-Auth-Process",
          tag: "Poshmark",
          title: "Tradesy authentication process: Weeding out the fakes",
          description: "An in-house team of experts scrutinizes any suspicious item that makes it past their smart technology detection.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Tradesy-Fees",
          tag: "Poshmark",
          title: "What You Need To Know About Tradesy Fees",
          description: "In this article, we\u2019ll discuss what you need to know about navigating your way with Tradesy fees and just what is Tradesy\u2019s fee structure all about.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Tradesy-Listing-Guidelines",
          tag: "Poshmark",
          title: "Tradesy's Listing Guidelines for Sellers",
          description: "This article will cover all of these guidelines and seller responsibilities that you need to follow when listing in Tradesy.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Tradesy-Return-Policy",
          tag: "Poshmark",
          title: "Tradesy Seller\u2019s Guide to Returns",
          description: "This article will discuss the basics of the Tradesy Return Policy and what to do as a seller if an item is returned.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Tradesy-Shipping-Options",
          tag: "Poshmark",
          title: "Selling on Tradesy: Shipping Options You Need To Consider",
          description: "If you have been selling on Tradesy for some time now, or you are a beginner, you listing items may be a breeze. But what about the logistics? From packing to shipping, here is what you should know about Tradesy's shipping methods and policies.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Tradesy-Shipping",
          tag: "Poshmark",
          title: "Tradesy Shipping 101: The Essentials to Get You Started",
          description: "Read and pick from the three shipping methods below if you haven\u2019t tried selling on Tradesy yet. You might even want to try two or all of these methods to see which one works best for you!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Tradesy-Smart-Pricing",
          tag: "Poshmark",
          title: "What You Need To Know About Tradesy Smart Pricing",
          description: "Know first-hand the smart pricing strategies you can use to optimize your sales and get more returning customers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Using-social-media-to-boost-poshmark-sales",
          tag: "Poshmark",
          title: "Tips To Boost Poshmark Sales With An Effective Instagram",
          description: "Being in social commerce is not just being there. So many sellers are already on social media, and as such, you must rise above the rest. There are 6 c\u2019s of social commerce that you must keep in mind:",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Vintage-Poshmark",
          tag: "Poshmark",
          title: "A Poshmark Reseller Guide: Where To Get Real Vintage Pieces",
          description: "Poshmark is not a vintage platform. As such, it is not easy to sell vintage. So, sellers must be very strategic about price, inventory, and sourcing items that you can resell on this online store.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Vinted-Bundles",
          tag: "Poshmark",
          title: "Vinted Sellers, Here's How You Can Boost Sales With Bundles",
          description: "Knowing the ins and outs may be overwhelming, but there are a couple of simple yet effective ways to boost your sales without having to research so much. These are creating Item Bundles and doing Item Bumps.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/eBay-Listing-Promotion",
          tag: "Poshmark",
          title: "A Beginner\u2019s Guide to eBay Listing Promotions",
          description: "What are Promoted listings on eBay? Explore the options you have in boosting your listings for increased chances of sales \u2013 plus practical tips to improve the quality of your listings to appear better on searches and attract more buyers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/eBay-Prohibited-Items",
          tag: "Poshmark",
          title: "eBay Prohibited Items You Should Not List",
          description: "Whether you are selling full-time or part-time on eBay, the giant e-commerce platform has several policies you must follow. This includes reviewing your listings and evaluating your items before posting them.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/eBay-SEO",
          tag: "Poshmark",
          title: "Boost Your eBay Sales With These Easy SEO Tips",
          description: "With billions of transactions every day, selling on eBay has become highly competitive, and listing down and putting up photos of your products is not enough. Having an effective marketing strategy is crucial, and this includes how you write product titles, descriptions, and even how you categorize each one.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 22nd, 2022",
          dateTime: "2022-01-22",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-bulk-upload",
          tag: "Poshmark",
          title: "Poshmark's Bulk Listing - List Faster and Sell More",
          description: "Reaching as many buyers as possible is the ultimate goal of any seller venturing into an online reselling platform. This is undeniably the most effective way of getting more potential buyers...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "December 29th, 2021",
          dateTime: "2021-12-29",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-automation",
          tag: "Mercari",
          title: "Mercari Automation - Your Virtual Assistants To Fast Selling",
          description: "Among the many helpful tips to selling a lot is to have your listings stay atop a user's feed. For instance, Poshmark has a niche audience...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "December 29th, 2021",
          dateTime: "2021-12-29",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-scams",
          tag: "Mercari",
          title: "The Three Typical Mercari Scams Every Seller Must be Aware Of",
          description: "Learn here what you need to know and tips to make you scam-proof",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "December 29th, 2021",
          dateTime: "2021-12-29",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-electronics",
          tag: "Poshmark",
          title: "Tips and Tricks in Selling Electronics on Poshmark",
          description: "Poshmark is now allowing sellers to list brand new or secondhand gadgets, electronics, and at times, even small appliances. As a seller, you have additional options to garner more potential buyers.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "December 27th, 2021",
          dateTime: "2021-12-27",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-love-note",
          tag: "Poshmark",
          title: "Poshmark Love Notes - The Sweetest Thing About Poshmark",
          description: "Get the most out of holiday shopping on Mercari by following these Christmas seller tips. Boost your sale with these easy and simple tips.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "December 27th, 2021",
          dateTime: "2021-12-27",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-holiday-items",
          tag: "Mercari",
          title: "Mercari Holiday Tips for Sellers",
          description: "Get the most out of holiday shopping on Mercari by following these Christmas seller tips. Boost your sale with these easy and simple tips.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "December 19th, 2021",
          dateTime: "2021-12-19",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-holiday",
          tag: "Poshmark",
          title: "The Poshmark Holiday Guide: What Items to Sell and How To Boost Your Sales",
          description: "Be in the know of the holiday items and selling strategies to help you make the most out of this festive \u2013 and generous \u2013 time of the year!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "December 19th, 2021",
          dateTime: "2021-12-19",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-competitors",
          tag: "Depop",
          title: "7 Marketplaces Like Depop - A Reseller's 2021 Guide",
          description: "Depop has become a subsidiary of Etsy, but they still have several strong competitors in the market. If you are looking for alternatives to Depop...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 21st, 2021",
          dateTime: "2021-10-21",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/how-much-does-poshmark-take",
          tag: "Poshmark",
          title: "Poshmark Fees 2021- An Easy Guide to Poshmark's Fees",
          description: "Like other online selling marketplaces, Poshmark also imposes fees to cover certain things to keep the platform organized and running...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 21st, 2021",
          dateTime: "2021-10-21",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-suspended-account",
          tag: "Poshmark",
          title: "Poshmark Suspended Account? - How This Happens And What You Can Do",
          description: "Poshmark values its sellers and buyers; hence it encourages its community to practice responsible interactions and transactions...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 21st, 2021",
          dateTime: "2021-10-21",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-prohibited-items",
          tag: "Poshmark",
          title: "What NOT to sell on Poshmark - Poshmark's Prohibited Items",
          description: "Poshmark prohibits certain items primarily for two reasons: first is to provide a seamless browsing experience for buyers...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 19th, 2021",
          dateTime: "2021-10-19",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-prohibited-items",
          tag: "Mercari",
          title: "Prohibited Mercari Items - Items that will get you banned from Mercari",
          description: "While some activities can seem normal to you, Mercari might have some rules against them...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 17th, 2021",
          dateTime: "2021-10-17",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/posh-sidekick-and-reseller-assistant",
          tag: "Poshmark",
          title: "Reseller Assistant, Posh Sidekick, and Poshmark Pro Tools owned by same person?",
          description: "Why do their business registration filing details look similar?",
          authorName: "Albert Chuang",
          authorImageUrl: "/static/images/blog/author/albert1.jpg",
          date: "October 17th, 2021",
          dateTime: "2021-10-17",
          readingDuration: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-description",
          tag: "Depop",
          title: "Selling On Depop? 9 Effective Tips for Listing on Depop",
          description: "Selling on online marketplaces like Depop can be part-time work for some. After all...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 17th, 2021",
          dateTime: "2021-10-17",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-shipping-over-5-lbs",
          tag: "Poshmark",
          title: "Poshmark's Overweight Shipping - Seller's Guide to Poshmark Shipping",
          description: "Poshmark has many restrictions on what can be sold, including the size and weight of an item...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 17th, 2021",
          dateTime: "2021-10-17",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-photo-tips",
          tag: "Poshmark",
          title: "Poshmark Photography Tips - Tricks for Quality Poshmark Listings",
          description: "Listing photos are crucial on online selling platforms like Poshmark, eBay, Mercari, Etsy, and other marketplaces...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 10th, 2021",
          dateTime: "2021-10-10",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-hashtags",
          tag: "Depop",
          title: "Depop Hashtags - How to use Hashtags in Depop make Sales",
          description: "Hashtags can be a quick way to keep track of a brand or a product on Depop. Learn more about what hashtags are and how...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "October 10th, 2021",
          dateTime: "2021-10-10",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-sharing-strategy",
          tag: "Poshmark",
          title: "Rethink your Poshmark Sharing Strategy - Turning Shares to Profit",
          description: "Sharing isn\u2019t as easy as it sounds, in fact, there\u2019s actually a proven strategy that follows the Poshmark guidelines...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 25th, 2021",
          dateTime: "2021-09-25",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-sourcing",
          tag: "Poshmark",
          title: "Poshmark Inventory: Where To Get Clothes That Sell",
          description: "As online marketplaces continue to thrive, it has become easier to pull out pre-loved apparel, accessories, and items from our closets...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 25th, 2021",
          dateTime: "2021-09-25",
          readingDuration: "12"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-affiliate-program",
          tag: "Poshmark",
          title: "The Posh Affiliate Program - Get PAID to use Poshmark",
          description: " Here\u2019s everything you need to know about how it works and what it's like, including the pros and cons of the affiliate program...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 25th, 2021",
          dateTime: "2021-09-25",
          readingDuration: "9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-vs-tradesy",
          tag: "Poshmark",
          title: "Poshmark vs Tradesy 2021 - What is Best for Sellers?",
          description: "When it comes to pre-owned clothing and personal items, buyers are spoilt for choice. There\u2019s a wide array of online marketplaces...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 24th, 2021",
          dateTime: "2021-09-24",
          readingDuration: "12"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-1099",
          tag: "Poshmark",
          title: "Poshmark, 1099 Forms, and Taxes - A Seller\u2019s Guide to 1099's",
          description: "Along with platform fees, online sellers are obligated to pay taxes. However, this does not apply to everyone, and some sellers...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 23rd, 2021",
          dateTime: "2021-09-23",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-algorithm",
          tag: "Poshmark",
          title: "The Poshmark Algorithm of 2021 - A Breakdown and Tips to Boost Sales",
          description: "Online selling is a laborious and time-consuming process. It is not a secret that making money by selling goods on the internet is not...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 23rd, 2021",
          dateTime: "2021-09-23",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-alternatives",
          tag: "Poshmark",
          title: "Beyond Poshmark - 7 Online Marketplaces For Your Pre-loved Clothes and Items",
          description: "If you are looking to try other websites, here are some online shops where you can turn your quality pre-loved clothes into cash...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 21th, 2021",
          dateTime: "2021-09-21",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/how-to-share-your-entire-closet-on-poshmark",
          tag: "Poshmark",
          title: "The Poshmark Sharing Guide - How to Effectively Share your Poshmark Closet",
          description: "Sharing your entire closet on Poshmark can be a great way to make some extra cash, and it's a lot easier than you might think...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 21st, 2021",
          dateTime: "2021-09-21",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/how-to-win-a-case-on-poshmark",
          tag: "Poshmark",
          title: "How to Win Cases on Poshmark - A step-by-step Guide for Poshmark Sellers!",
          description: "If you're a seller on Poshmark, you've probably experienced (or anxious about) having to handle open cases on return requests...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 21st, 2021",
          dateTime: "2021-09-21",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-taxes",
          tag: "Poshmark",
          title: "The Seller\u2019s Handbook to Poshmark Taxes - 2021",
          description: "As someone who earns through Poshmark, it is your responsibility to include on your yearly tax returns your Poshmark earnings to avoid any problems with the IRS...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 20th, 2021",
          dateTime: "2021-09-20",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-tips",
          tag: "Depop",
          title: "The 10 Tips for a Successful Depop Store - The Depop Seller Guide",
          description: "If you're looking for essential tips and tricks to have a successful Depop shop, this blog post is for you. Here are nine tips and tricks that can help make your Depop...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "September 20th, 2021",
          dateTime: "2021-09-20",
          readingDuration: "12"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-virtual-assistants",
          tag: "Poshmark",
          title: "Poshmark Virtual Assistants - The Guide to Doing It All with Poshmark Virtual Assistants",
          description: "It takes plenty of work to maintain a successful Poshmark closet and as a seller, you\u2019ll find that as you continue to grow your business it\u2019s easy to become overwhelmed...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 10th, 2021",
          dateTime: "2021-08-10",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-price-drop-strategy",
          tag: "Poshmark",
          title: "The Poshmark Price Drop Strategy - A Seller\u2019s Guide to More Sales",
          description: "Poshmark sellers are well aware of how important pricing is in making a profit on the platform. But the thing is, the way to a sure sale is not always as simple...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 10th, 2021",
          dateTime: "2021-08-10",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-vacation-mode",
          tag: "Mercari",
          title: "Mercari Tip: How To Turn On Vacation Mode On Your Account",
          description: "The prominence of the online marketplace has made it easier for people to earn and at the same time, give away their pre-loved items\u2014similar to a garage sale...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 10th, 2021",
          dateTime: "2021-08-10",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-seller-fees",
          tag: "Depop",
          title: "Everything You Need To Know About Depop Selling Fees",
          description: "From vintage items, handmade products, accessories, to secondhand possessions, there is no limit to what you can sell on Depop. It may be viewed as an online thrift...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 10th, 2021",
          dateTime: "2021-08-10",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-shipping-fees",
          tag: "Depop",
          title: "Depop Shipping Fees for Sellers",
          description: "Depop is a social media platform for buying and selling second-hand items. The company offers sellers the option to choose their own shipping costs. However...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 10th, 2021",
          dateTime: "2021-08-10",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/how-to-negotiate-on-poshmark",
          tag: "Poshmark",
          title: "How To Negotiate On Poshmark - The Seller's Guide to Effective Offers",
          description: "As with any business, negotiation is a key factor that makes a transaction successful. Find out here how you can effectively negotiate with your potential buyers...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 10th, 2021",
          dateTime: "2021-08-10",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-offer-etiquette",
          tag: "Poshmark",
          title: "The Poshmark Offer Etiquette - A Step-by-Step Guide",
          description: "The Poshmark platform is constantly evolving to accommodate more features to make the posher's purchase experience as seamless as possible. For Poshmark sellers...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 3rd, 2021",
          dateTime: "2021-08-03",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-scammer",
          tag: "Poshmark",
          title: "Poshmark Scams - A Seller\u2019s Guide to Common Poshmark Scams and What to Do!",
          description: "Poshmark\u2019s warm community of sellers and buyers (many of which interchangeably wear a hat as both!) thrives on mutual respect and positive energy. As with other...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "August 3rd, 2021",
          dateTime: "2021-08-03",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/crosslisting-app",
          tag: "Crosslisting",
          title: "Crosslisting Apps: Features and Comparisons",
          description: "Many people nowadays are selling online as it indeed is a good source of income. The popularity of online shopping for so many things, including second-hand...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 23rd, 2021",
          dateTime: "2021-07-23",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshfest",
          tag: "Poshmark",
          title: "PoshFest 2021 - All about it and What to expect",
          description: "From the daily virtual Posh Parties to the regular Posh N Sip meet-ups, the Poshmark community indeed thrives on constant interaction and...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 23rd, 2021",
          dateTime: "2021-07-23",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/trick-to-selling-on-mercari",
          tag: "Mercari",
          title: "Top 8 Mercari Tips and Tricks to Boost Sales - 2021",
          description: "Once you joined the online marketplace, you discovered how fast and convenient it is to become an entrepreneur in the digital landscape...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 23rd, 2021",
          dateTime: "2021-07-23",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-vacation-mode",
          tag: "Poshmark",
          title: "Poshmark Vacation Mode - Poshmark Sellers Guide",
          description: "Are you a Poshmark seller and are planning a vacation? Or just want to get your closet on hold for a while? Poshmark Vacation Mode is...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 23rd, 2021",
          dateTime: "2021-07-23",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/depop-bot",
          tag: "Depop",
          title: "The Best Depop Bots of 2021: The Ultimate Guide",
          description: "One of the greatest things technology has made possible is the rise of online selling. Not only does it allow you to reach more potential...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 19th, 2021",
          dateTime: "2021-07-19",
          readingDuration: "17"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-boutique",
          tag: "Poshmark",
          title: "What does Boutique mean in Poshmark? - The Guide to Boutique Selling",
          description: "Poshmark provides an opportunity for active sellers to conduct business by providing a platform to set up, list things, and become founders...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 14th, 2021",
          dateTime: "2021-07-14",
          readingDuration: "8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/vendoo",
          tag: "Vendoo",
          title: "Vendoo \u2013 Is Vendoo Worth It For You?",
          description: "Online selling has become one of the most in-demand side hustle nowadays. Aside from being able to sell in the comforts of your home with...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 11th, 2021",
          dateTime: "2021-07-11",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-offer-chart",
          tag: "Poshmark",
          title: "Poshmark Offer Chart \u2013 How to price your listing + offers",
          description: "Poshmark has changed over the years incorporating many new features such as different ways for retailers to adjust pricing. Along with this is...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 11th, 2021",
          dateTime: "2021-07-11",
          readingDuration: "6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-closet-clear-out",
          tag: "Poshmark",
          title: "Closet Clear Out! - The Complete Guide for the Best Sales",
          description: "Closet Clear Out is a Poshmark promotion that offers discounted shipping to buyers who avail of price drops on your listings. Not to be confused...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 10th, 2021",
          dateTime: "2021-07-10",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/list-perfectly",
          tag: "List Perfectly",
          title: "List Perfectly - Is ListPerfectly Worth It For You?",
          description: "Selling online means maximizing the tools and reselling platforms available to have many sales. For most resellers, time is always of the...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 8th, 2021",
          dateTime: "2021-07-08",
          readingDuration: "11"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/how-to-sell-on-poshmark-fast",
          tag: "Poshmark",
          title: "Sell Faster on Poshmark - Successful Tips for Selling",
          description: "For serious sellers, Poshmark is a side hustle turned into a full-time job that brings in another revenue stream by reselling used goods. Anyone...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 8th, 2021",
          dateTime: "2021-07-08",
          readingDuration: "7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-bulk-listing-actions",
          tag: "Poshmark",
          title: "Poshmark Update - Bulk Listing Actions and All You Need to Know",
          description: "The Poshmark community has recently received the news about the new Poshmark update alert released on June 21, 2021, with the claim that promoting...",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 6th, 2021",
          dateTime: "2021-07-06",
          readingDuration: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/yc-s21",
          tag: "Fundraising",
          title: "OneShop joins Y Combinator\u2019s Summer 2021 Batch",
          description: "Both Aaron and I are excited to share that OneShop is part of Y Combinator\u2019s summer batch this year...",
          authorName: "Albert Chuang",
          authorImageUrl: "/static/images/blog/author/albert1.jpg",
          date: "June 24th, 2021",
          dateTime: "2021-06-24",
          readingDuration: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: constants/* GridStyle.MB4Unit */.Hy.MB4Unit,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            style: constants/* TextStyle.T42B */.pn.T42B,
            children: "OneShop Snippets"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            style: [constants/* TextStyle.T16R */.pn.T16R, constants/* TextStyle.CDarkGray */.pn.CDarkGray],
            children: "Quick tips for selling on marketplaces! We take commonly asked questions from sellers and answer them. Share them with your friends."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/Poshmark-Mark-As-Sold",
          tag: "Poshmark Snippets",
          title: "How to Mark a Poshmark Listing as Sold",
          description: "Sold an item elsewhere? Make sure you delist your items to prevent double selling!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "January 29th, 2022",
          dateTime: "2022-01-29",
          readingDuration: "2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/mercari-bot",
          tag: "Mercari Snippets",
          title: "Mercari Bots - The Complete Guide to Mercari Automation",
          description: "Learn how to automate the small things to boost your Mercari sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 23rd, 2021",
          dateTime: "2021-07-23",
          readingDuration: "5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-bulk-share-jail",
          tag: "Poshmark Snippets",
          title: "Can Bulk Sharing Land You in Poshmark\u2019s Share Jail?",
          description: "Find out if you can get in share jail using Poshmark\u2019s bulk sharing tool!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 14th, 2021",
          dateTime: "2021-07-14",
          readingDuration: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-bulk-share-sales",
          tag: "Poshmark Snippets",
          title: "Poshmark Bulk Sharing - Not seeing results?",
          description: "Poshmark\u2019s bulk sharing tool can help save time, but learn why it may not lead to more sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 14th, 2021",
          dateTime: "2021-07-14",
          readingDuration: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-offer-to-likers",
          tag: "Poshmark Snippets",
          title: "Everything about Poshmark\u2019s Offers to Likers",
          description: "Master offers to likers in Poshmark to boost your sales!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 11th, 2021",
          dateTime: "2021-07-11",
          readingDuration: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-one-item-bundle",
          tag: "Poshmark Snippets",
          title: "What do I do with Single Item Bundles on Poshmark?",
          description: "Did someone leave you hanging with a single item bundle? Here\u2019s what it could mean and what you can do!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 8th, 2021",
          dateTime: "2021-07-08",
          readingDuration: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-bad-rating",
          tag: "Poshmark Snippets",
          title: "So you received a low rating on Poshmark\u2026",
          description: "Don\u2019t let a negative rating ruin your day. Learn what you can do from here!",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 8th, 2021",
          dateTime: "2021-07-08",
          readingDuration: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogPreviewCell, {
          href: "/blog/poshmark-cancel-sale",
          tag: "Poshmark Snippets",
          title: "How to Cancel an Order on Poshmark",
          description: "If you haven\u2019t shipped an item yet, it\u2019s still possible to cancel an order before it\u2019s sent out! Here\u2019s how to do it.",
          authorName: "The OneShop Team",
          authorImageUrl: "/static/images/blog/author/oneshop2.png",
          date: "July 8th, 2021",
          dateTime: "2021-07-08",
          readingDuration: "1"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  },
  contentContainer: {
    paddingTop: 6 * constants/* Grid.dp */.rj.dp(12),
    alignItems: 'center'
  },
  contentColumn: {
    width: constants/* Grid.dp */.rj.dp(640),
    maxWidth: '100%'
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/index.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "OneShop helps sellers sell on marketplaces."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "OneShop helps sellers sell on marketplaces."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image')]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Home, {})]
  });
}

/***/ }),

/***/ 45867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22120);
/* harmony import */ var src_components_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var Footer = function Footer() {
  var desktopWidth = (0,react_responsive__WEBPACK_IMPORTED_MODULE_5__.useMediaQuery)({
    minWidth: 860
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
    style: styles.root,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: [desktopWidth && src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLDR */ .Hy.FLDR, styles.contentColumn, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MB4Unit */ .Hy.MB4Unit],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLDR */ .Hy.FLDR, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLF1 */ .Hy.FLF1],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: styles.navLogo,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/static/images/nav-logo.png?v=1",
                width: 294,
                height: 60
              })
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'PRODUCT'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'OneShop'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/pricing",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Pricing'
                  })
                })
              })
            })]
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLDR */ .Hy.FLDR, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLF1 */ .Hy.FLF1],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'COMPANY'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/contact",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Contact'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "https://www.workatastartup.com/companies/oneshop",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Jobs'
                  })
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'RESOURCES'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/policies",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Marketplace Policies'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/blog",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Blog'
                  })
                })
              })
            })]
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLDR */ .Hy.FLDR, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLF1 */ .Hy.FLF1],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'SOCIAL'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "https://www.youtube.com/channel/UC7wKt6XZoagcp8Ry71d4ZWA",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'YouTube'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "https://www.facebook.com/oneshopcompany",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Facebook'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "https://www.instagram.com/oneshopcom/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Instagram'
                  })
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'LEGAL'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/legal/privacy",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Privacy'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/legal/terms",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Terms'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/legal/cancellation",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Cancellations'
                  })
                })
              })
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: styles.disclaimerColumn,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: styles.edgeGutter,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T10R */ .pn.T10R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
          children: '© 2024 Inventory Systems, Inc.'
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T10R */ .pn.T10R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
          children: 'List Perfectly is a trademark of ListPerfectly, Inc. Vendoo is a trademark of Vendoo, Inc. Poshmark is a trademark of Poshmark, Inc. Mercari is a trademark of Mercari, Inc. Tradesy is a trademark of Tradesy, Inc. Depop is a trademark of Depop Ltd. Etsy is a trademark of Etsy, Inc. Kidizen is a trademark of Kidizen, Inc. Grailed is a trademark of Grailed, Inc. Heroine is a trademark of Grailed, Inc. eBay is a trademark of eBay, Inc. Facebook is a trademark of Facebook, Inc. Facebook Marketplace is a trademark of Facebook, Inc. OneShop is not endorsed, certified, or affiliated by List Perfectly, Vendoo, mercariBOT, ResellKit, SellerInsight, PrimeLister, Cross List It, Hammoq, ListingJoy, Crosslist, Poshmark, Tradesy, Mercari, Depop, Grailed, Facebook Marketplace, eBay, Kidizen, or Etsy. The names List Perfectly, Vendoo, Crosslist, Poshmark, Tradesy, Mercari, Depop, Grailed, Facebook Marketplace, eBay, Kidizen, and Etsy, as well as related names, marks, emblems and images are registered trademarks of their respective owners.'
        })]
      })
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7___default().create({
  root: {
    alignItems: 'center',
    paddingTop: 4 * src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(36)
  },
  navLogo: {
    maxWidth: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(100)
  },
  footerColumn: {
    flex: 1,
    marginBottom: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(24)
  },
  contentColumn: {
    width: '100%',
    maxWidth: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(960)
  },
  disclaimerColumn: {
    width: '100%',
    maxWidth: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(960)
  },
  edgeGutter: {
    paddingHorizontal: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(12)
  },
  heroImage: {
    width: '100%'
  },
  featurePreview: {
    padding: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(24),
    borderRadius: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(6),
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .NewColor.White */ .Wq.White,
    zIndex: 1
  },
  heroButton: {
    height: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(48),
    borderRadius: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(24)
  },
  actionRow: {
    flexDirection: 'row',
    justifyContent: 'center'
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (Footer);

/***/ }),

/***/ 82969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22120);
/* harmony import */ var src_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71862);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);










var NavBar = function NavBar() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("header", {
    style: {
      position: 'sticky',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 3,
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(5px)'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: styles.navRoot,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: styles.navContentRoot,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.logoImg,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "/",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "/static/images/nav-logo.png?v=1",
                width: 294,
                height: 60,
                priority: true
              })
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.rightColumn,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "/signup",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(src_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                type: "primary",
                style: styles.signupButton,
                children: 'Sign up'
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "/login",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(src_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                type: "secondary",
                style: styles.signupButton,
                children: 'Login'
              })
            })
          })]
        })]
      })
    })
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7___default().create({
  navRoot: {
    alignItems: 'center'
  },
  navContentRoot: {
    width: '100%',
    height: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(66),
    maxWidth: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(1200),
    paddingHorizontal: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12),
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  logoImg: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(117),
    height: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(24)
  },
  rightColumn: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  signupButton: {
    marginLeft: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12)
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (NavBar);

/***/ }),

/***/ 67801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(63317);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,9774,2888,179], function() { return __webpack_exec__(67801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);